"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Checkbox;
var React = _interopRequireWildcard(require("react"));
var _utils = require("../utils");
var _Input = require("./Input");
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function Checkbox(props) {
  var values = !!props.checked ? Array.isArray(props.checked) ? props.checked : [props.checked] : [];
  var isMulti = !!props.items && Array.isArray(props.items) && props.items.length > 0;
  var items = isMulti ? props.items : [{
    text: props.text
  }];
  var boxProps = {
    className: (0, _utils.clsNames)('un-input-checkbox', props.vertical && '-vertical', props.sm && '-sm', !props.m0 && 'un-boxmargin', props.className)
  };
  var _onChange = function onChange(e, value, item) {
    var checked = e.target.checked;
    if (!!props.onChange) {
      if (isMulti) {
        var checkedValues = checked ? _toConsumableArray(values) : values.filter(function (v) {
          return v !== value;
        });
        if (checked) checkedValues.push(value);
        var checkedItems = items.filter(function (o, i) {
          return checkedValues.indexOf((0, _utils.test)(o.value, o.id, typeof o === 'string' || typeof o === 'number' ? o : null, i)) >= 0;
        });
        props.onChange(checkedValues, checkedItems);
      } else {
        props.onChange(checked, item);
      }
    }
  };
  var input = /*#__PURE__*/React.createElement("div", boxProps, items.map(function (o, x) {
    if (o === true) return /*#__PURE__*/React.createElement("div", {
      key: 'check_' + x,
      className: "un-input-checkbox-div"
    });
    var id = 'check_name_' + (0, _utils.uid)();
    var label = (0, _utils.test)(o.text, o.name, o.label, typeof o === 'string' || typeof o === 'number' ? o : null);
    var value = (0, _utils.test)(o.value, o.id, typeof o === 'string' || typeof o === 'number' ? o : null, x);
    var checked = isMulti ? values.indexOf(value) >= 0 : props.checked;
    var inputProp = {
      type: 'checkbox',
      id: id,
      value: value,
      checked: checked,
      className: '_native',
      onChange: function onChange(e) {
        return _onChange(e, value, o);
      }
    };
    return /*#__PURE__*/React.createElement("div", {
      key: 'check_' + x,
      className: (0, _utils.clsNames)('un-input-checkbox-item', o.className, checked && '-checked', props.r0 && x + 1 === items.length && '-r0')
    }, /*#__PURE__*/React.createElement("div", {
      className: "_check"
    }, /*#__PURE__*/React.createElement("input", inputProp), /*#__PURE__*/React.createElement(_Icon.default, {
      name: 'check',
      solid: true,
      className: '_icon'
    })), !(0, _utils.isEmpty)(label) && typeof label !== 'boolean' && /*#__PURE__*/React.createElement("label", {
      className: "_label",
      htmlFor: id
    }, label), !!o.component && o.component);
  }), !props.form && !!props.label && (0, _Input.createInputboxLabel)(props.label, true, '-left'));
  if (props.form) return (0, _Input.createFormitem)(input, props);
  if (typeof props.classBox === 'string') return /*#__PURE__*/React.createElement("div", {
    className: props.classBox
  }, input);
  return input;
}